import type { ModalProps } from "react-native";

// this is used to disable animations in storybook tests, as modals fail to be accessible if they are not fully rendered
const isStorybookTest =
  typeof globalThis !== "undefined" && (globalThis as { __STORYBOOK_TEST__?: boolean }).__STORYBOOK_TEST__ === true;

export const getModalAnimationType = (
  defaultAnimation: ModalProps["animationType"] = "fade"
): ModalProps["animationType"] => {
  return isStorybookTest ? "none" : defaultAnimation;
};
